import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'string',
  name: 'String',
  category: 'utilities',
  description: 'Perform string manipulation operations like uppercase, replace, split, and concat',
  icon: 'Type',
  color: 'cyan',
  version: '1.0.0',

  group: ['transform'],

  defaults: {
    name: 'String',
    color: '#06b6d4',
  },

  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],

  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],

  tags: ['string', 'text', 'uppercase', 'lowercase', 'replace', 'split', 'concat', 'trim', 'substring'],

  metadata: {
    documentation: 'https://docs.n8n.io/code/builtin/data-transformation-functions/strings/',
  },
};

export default definition;
